
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WordList',
  props: {
    words: Array
  }
})
